module.exports = __webpack_public_path__ + "static/img/img_k.638890ef.png";